import React from 'react'
import PinInput from 'react-pin-input'
import { Button, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface PinProps {
  handlePinInputChange: (event: string) => void
  onClickResendPin: () => void
  onClickEditPhoneNumber: () => void
  resendPinLoading: boolean
  hasPinError: boolean
}

export const Pin: React.FC<PinProps> = ({
  handlePinInputChange,
  onClickEditPhoneNumber,
  onClickResendPin,
  resendPinLoading,
  hasPinError
}) => {
  return (
    <S.Container hasPinError={hasPinError}>
      <Typography variant="content2" weight='bold'>Número do PIN *</Typography>

      <PinInput
        length={4}
        secret={false}
        type="numeric"
        inputMode='number'
        autoSelect
        onChange={value => handlePinInputChange(value)}
      />

      <S.WrapperButtons>
        <Button variant='text' disabled={resendPinLoading} uppercase={false} onClick={onClickResendPin}>Reenviar PIN</Button>
        <Button variant='text' uppercase={false} onClick={onClickEditPhoneNumber}>Editar telefone</Button>
      </S.WrapperButtons>
    </S.Container>
  )
}